module.exports = __webpack_public_path__ + "img/je.db9c6cf.svg";